export default __webpack_public_path__ + "static/media/Hatefreeze Ring.b8ac425d.jpg";